import { PatternFormat } from 'react-number-format';
import { useSelector } from 'react-redux';
import { RootState } from 'store/reducer';
import { Country } from 'types/country';
import appHelpers from 'utils/app-urls';
import { Dropdown } from '../Forms/Dropdown/Dropdown';
import messages from './messages';

const PhoneNumberInput = ({
  phoneNumber,
  dialCode,
  countries,
  country,
  onChangeCountry,
  countryPicture,
  onChangeNumber,
  className,
  lightMode,
  noPaddingX,
  countryLabel,
}: {
  phoneNumber: string;
  dialCode: string;
  countries: Country[];
  country: string;
  onChangeCountry: (value: string) => void;
  countryPicture: string;
  onChangeNumber: (value: any) => void;
  className?: string;
  lightMode?: boolean;
  noPaddingX?: boolean;
  countryLabel?: string;
}) => {
  const cdnURL = appHelpers.getCDNUrl();
  const defaultDialCode = countries.find(
    (c: any) => c.code === country,
  )?.dialCode;

  const { language } = useSelector((state: RootState) => state.language);
  const inputMessages = messages[language];

  return (
    <div
      className={`pb-4 pt-5 rounded-lg transition-all ${className} ${
        lightMode ? 'bg-transparent' : 'bg-background shadow-xl'
      } ${noPaddingX || 'px-4'}`}>
      <div className={`${noPaddingX || 'px-3'} py-2 flex flex-col`}>
        <label className="block font-normal leading-5 text-gray-900">
          {countryLabel || inputMessages.country}
        </label>
        <Dropdown
          className="bg-transparent text-white py-4 border-0 border-b-2 form-input rounded-none sm:leading-5 sm:text-sm w-full"
          options={countries.map(t => ({
            id: t.code,
            value: t.code,
            name: t.name,
          }))}
          autocomplete
          value={country}
          onChange={onChangeCountry}
        />
      </div>
      <div className={`${noPaddingX || 'px-3'} py-2 flex flex-col`}>
        <label className="block font-normal leading-5 text-gray-900">
          {inputMessages.phoneNumber}
        </label>
        <div className="flex flex-row">
          <div className="bg-transparent rounded-none border-0 pr-2 form-input text-white pl-0 pt-3 border-b-2">
            {countryPicture && (
              <img
                className="p-1 w-8 rounded-time-item  sm:leading-5 ml-0"
                src={`${cdnURL}assets/flags/square/${countryPicture}.svg`}
                alt={country}
              />
            )}
          </div>
          <label
            htmlFor="phoneNumber"
            className={`bg-transparent focus:outline-none ml-0 pl-0
                             py-4 border-0 border-b-2 form-input rounded-none sm:leading-5 sm:text-sm pr-2 ${
                               lightMode ? 'text-black' : 'text-white'
                             }`}>
            +{dialCode || defaultDialCode}
          </label>
          <PatternFormat
            name="phoneNumber"
            id="phoneNumber"
            format="###############"
            className={`border-0 border-b-2 ${
              lightMode
                ? 'text-black border-light-grey'
                : 'text-white border-header-text'
            } outline-none bg-transparent focus:outline-none py-4 form-input rounded-none sm:leading-5 sm:text-sm flex-1`}
            type="tel"
            value={phoneNumber}
            onChange={(e: any) => onChangeNumber(e.target.value.trim())}
          />
        </div>
      </div>
    </div>
  );
};

export default PhoneNumberInput;
